export default __webpack_public_path__ + "static/media/real-stories-background.d067708b.png";